module.exports = __webpack_public_path__ + "img/39.0d16a9b9.jpg";